import React from 'react'
import useUniqueId from '../../hooks/use-unique-id'

export enum InputType {
  EMAIL = 'email',
  NUMBER = 'number',
  PASSWORD = 'password',
  SEARCH = 'search',
  TEL = 'tel',
  TEXT = 'text',
}

export enum AutoCompleteType {
  NONE = '',
  OFF = 'autocomplete-off',
  GIVEN_NAME = 'given-name',
  FAMILY_NAME = 'family-name',
  STREET_ADDRESS = 'street-address',
  POSTAL_CODE = 'postal-code',
  ADDRESS_LEVEL2 = 'address-level2',
  EMAIL = 'email',
  TEL = 'tel',
}

type Props = {
  id?: string
  type: InputType
  name?: string
  value?: string
  onChange?: (arg0: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (arg0: React.KeyboardEvent<HTMLInputElement>) => void
  onFocus?: (arg0: React.FocusEvent<HTMLInputElement>) => void
  onBlur?: (arg0: React.FocusEvent<HTMLInputElement>) => void
  error?: boolean
  customErrorText?: string
  onValidation?: (arg0: boolean) => void
  placeHolder?: string
  required?: boolean
  autoComplete?: AutoCompleteType
  readOnly?: boolean
  hiddenLabel?: boolean
  className?: string
  inputClassName?: string
  autoFocus?: boolean
  maxLength?: number
}
const Input = ({
  type,
  id,
  name,
  value,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  autoComplete = getAutoCompleteFromType(type),
  readOnly = false,
  className = '',
  autoFocus = false,
  maxLength,
  placeHolder = '',
  required = false,
}: Props) => {
  const uniqueId = useUniqueId(type)

  return (
    <input
      type={type}
      id={id ?? uniqueId}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      className={className}
      required={required}
      name={name}
      placeholder={placeHolder}
      autoComplete={autoComplete}
      readOnly={readOnly}
      autoFocus={autoFocus}
      maxLength={maxLength}
    />
  )
}

const getAutoCompleteFromType = (type: InputType) => {
  switch (type) {
    case InputType.EMAIL:
      return AutoCompleteType.EMAIL
    case InputType.NUMBER:
      return AutoCompleteType.TEL
    default:
      return AutoCompleteType.NONE
  }
}

export default Input
